import React, { Component } from 'react';
import wx from 'weixin-js-sdk';
import { GetRequest } from "../../utils/util";
import { Toast } from 'antd-mobile'
import './index.scss';

var browser = {
    versions: function () {
        var u = navigator.userAgent;
        return {
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
        };
    }(),
}

class AuthenticateJump extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countdown: 5,
            projectId: null,
            userNo: null,
            telephone: null,
            encryptedParam: null,
            errorMsg: null,
            showModal: false
        };
        this.timer = null;
    }

    componentDidMount() {
        document.title = "趣智校园"
        let search = window.location.search.slice(1)
        let params = search.split('&')
        var theRequest = new Object()
        for (let i = 0; i < params.length; i++) {
            theRequest[params[i].split("=")[0]] = decodeURIComponent(params[i].substring(params[i].indexOf('=') + 1));
        }
        this.setState({
            projectId: theRequest?.projectId,
            userNo: theRequest?.userNo,
            telephone: theRequest?.telephone,
            encryptedParam: theRequest?.ticket,
            errorMsg: theRequest?.errorMsg
        })
        if (!theRequest?.errorMsg) {
            this.startCountdown()
        }
    }

    onBack = () => {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        const paramsInfo = new URLSearchParams({
            encryptedParam: this.state.encryptedParam,
            externalType: 'scitc_edu',
            telephone:this.state.telephone,
            projectId:this.state.projectId,
        });
        // window.location.href = `weixin://dl/business/?appid=wx2ded7c2a06ef15ea&path=pages/index/index&env_version=trial&query=${encodeURIComponent(paramsInfo.toString())}`

        window.location.href = `weixin://dl/business/?appid=wx2ded7c2a06ef15ea&path=pages/index/index&query=${encodeURIComponent(paramsInfo.toString())}`
        // var ua = navigator.userAgent.toLowerCase();
        // if (ua.includes('micromessenger')) {
        //     // 正式环境小程序
        //     // window.location.href = `weixin://dl/business/?appid=wx2ded7c2a06ef15ea&path=pages/index/index&query=${encodeURIComponent(paramsInfo.toString())}`
        //   // 体验版小程序
        //     window.location.href = `weixin://dl/business/?appid=wx2ded7c2a06ef15ea&path=pages/index/index&env_version=trial&query=${encodeURIComponent(paramsInfo.toString())}`

        // } else {
        //     alert('请在微信内打开')
        // }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    // 倒计时逻辑
    startCountdown = () => {
        this.timer = setTimeout(() => {
            if (this.state.countdown <= 1) {
                // this.showConfirm();
                this.onBack()
            } else {
                this.setState(
                    prevState => ({ countdown: prevState.countdown - 1 }),
                    this.startCountdown
                );
            }
        }, 1000);
    };

    showConfirm = () => {
        this.onBack()
        // this.setState({ showModal: true });
        // setTimeout(() => {
        //     this.onBack()
        // }, 1000);
    }
    onCancel = () => {
        this.setState({ showModal: false });
    }
    renderModal = () => {
        const { showModal } = this.state;
        return (
            <>
                {/* 底部透明灰色层  */}
                <div className={showModal ? "mask display2" : "mask"}></div>
                {/* <!-- 提示层 --> */}
                <div className={showModal ? "board-authJump board display" : "board-authJump board"}>
                    <div className="jump-modal">
                        <div className='text'>
                            即将打开“趣智校园”小程序
                        </div>
                        <div className='button'>
                            <span className='btn-cancel' onClick={this.onCancel}>取消</span>
                            <span className='btn-submit' onClick={this.onBack}>打开</span>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    render() {
        const { userNo, telephone, errorMsg } = this.state
        return (
            !errorMsg ? <>
                {this.renderModal()}
                <div style={{
                    textAlign: 'center',
                    marginTop: '10vh'
                }}>
                    <img style={{ width: '80px' }} src={require('../../assets/quzhi.png')} /> {/* 趣智校园图标 */}
                    <div style={{
                        fontSize: '16px',
                        marginTop: '30px'
                    }}><span style={{ fontWeight: 'bold' }}>学号：</span>{userNo}</div>
                    <div style={{
                        fontSize: '16px',
                        marginTop: '10px'
                    }}><span style={{ fontWeight: 'bold' }}>手机号：</span>{telephone}</div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '100px'
                    }}>
                        <button
                            onClick={this.showConfirm}
                            style={{
                                width: '300px',
                                padding: '8px 0',
                                fontSize: '16px',
                                background: 'linear-gradient( 270deg, #5BA1FD 0%, #6FBDFF 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '30px',
                                cursor: 'pointer'
                            }}
                        >
                            {this.timer ? this.state.countdown + 's后' : null}跳转“趣智校园”
                        </button>
                    </div>
                </div>
            </> : <div style={{
                textAlign: 'center',
                marginTop: '10vh',
                padding: '0 24px',
                fontSize: '16px'
            }}>
                <img style={{ width: '80px' }} src={require('../../assets/quzhi.png')} /> {/* 趣智校园图标 */}
                <div style={{
                    marginTop: '30px'
                }}><span style={{ fontWeight: 'bold' }}>学号：</span>{userNo}</div>
                <div style={{
                    marginTop: '80px',
                    textAlign: 'left',
                    fontWeight: 'bold' 
                }}>错误提示：</div>
                <div style={{
                    textAlign: 'left',
                    marginTop: '16px',
                }}>{errorMsg}</div>
            </div>
        );
    }
}

export default AuthenticateJump;